import { countryJsonType } from "../ReduxTool/Slice/Auth/types";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
export { loadCountryMaster as loadMobileCountries } from "./countryMaster";

const UAE_MOBILE_REGEX = "^(?:5[02-68]\\d{7})$";

export const getLocalMobileDigits = (phone: string, dialCode?: string | null): string => {
  const digits = (phone ?? "").replace(/\D/g, "");
  const prefix = (dialCode ?? "").replace(/\D/g, "");
  return prefix && digits.startsWith(prefix) ? digits.slice(prefix.length) : digits;
};

export const validateCountryMobile = (localDigits: string, country?: countryJsonType | null): string | null => {
  if (!localDigits) return "This field is required";
  if (!country) {
    return "Mobile validation is unavailable for this country. Please try again later.";
  }

  const { mobile_min_length: min, mobile_max_length: max } = country;
  if ((min != null && localDigits.length < min) || (max != null && localDigits.length > max)) {
    const length = min != null && max != null
      ? min === max ? `${min} digits` : `${min} to ${max} digits`
      : min != null ? `at least ${min} digits` : `at most ${max} digits`;
    return `Mobile number must be ${length}`;
  }

  if (country.mobile_regex?.trim()) {
    try {
      if (new RegExp(country.mobile_regex).test(localDigits)) return null;
      if (country.alpha2code?.toUpperCase() === "AE" &&
        country.mobile_regex === UAE_MOBILE_REGEX && min === 9 && max === 9) {
        return "After +971, enter 9 digits starting with 50, 52, 53, 54, 55, 56, or 58.";
      }
      if (country.alpha2code?.toUpperCase() === "AU") {
        return localDigits.startsWith("4")
          ? "Australian mobile number must have a valid 4xx prefix after +61"
          : "Australian mobile number must start with 4 after +61";
      }
      return `Please enter a valid ${country.countryname} mobile number for ${country.countrycode}`;
    } catch {
      // Fall back to local phone metadata if the API regex is malformed.
    }
  }

  const dialCode = country.countrycode?.replace(/\D/g, "");
  if (!dialCode) {
    return "Mobile validation is unavailable for this country. Please try again later.";
  }
  const parsed = parsePhoneNumberFromString(`+${dialCode}${localDigits}`);
  const numberType = parsed?.getType();
  return parsed?.isValid() && (!numberType || numberType === "MOBILE" || numberType === "FIXED_LINE_OR_MOBILE")
    ? null
    : `Please enter a valid ${country.countryname} mobile number for ${country.countrycode}`;
};
